"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const getCurrentPeriod_1 = require("../../util/summary/getCurrentPeriod");
const formatClock_1 = require("./formatClock");
const getNextPeriodExpectedStartDate_1 = require("./getNextPeriodExpectedStartDate");
const getRunningClock_1 = require("./getRunningClock");
const DAY_IN_SECONDS = 24 * 60 * 60;
const HOUR_IN_SECONDS = 60 * 60;
const MINS_IN_SECONDS = 60;
const positiveSecondsToDHMS = (seconds) => {
    const days = Math.floor(seconds / DAY_IN_SECONDS);
    const hours = Math.floor((seconds - days * DAY_IN_SECONDS) / HOUR_IN_SECONDS);
    const minutes = Math.floor((seconds - (days * DAY_IN_SECONDS + hours * HOUR_IN_SECONDS)) / MINS_IN_SECONDS);
    const secs = Math.floor(seconds - (days * DAY_IN_SECONDS + hours * HOUR_IN_SECONDS + minutes * MINS_IN_SECONDS));
    return {
        days,
        hours,
        mins: minutes,
        secs
    };
};
const secondsToDHMS = (seconds) => {
    if (seconds > -1) {
        return positiveSecondsToDHMS(seconds);
    }
    const countdown = positiveSecondsToDHMS(-seconds);
    const timeScale = ['days', 'hours', 'mins', 'secs'];
    timeScale.find((unit) => {
        if (countdown[unit]) {
            countdown[unit] = -1 * countdown[unit];
            return true;
        }
        return false;
    });
    return countdown;
};
exports.calcClock = (matchDate, sportName, clockInfo, periods, currentPeriodCode, config, skewMsAdjustment = 0) => {
    const currentPeriod = getCurrentPeriod_1.getCurrentPeriod(currentPeriodCode, periods);
    let tillNextTick;
    let clock;
    let countdownClock;
    let countdown;
    let secondsSinceStart;
    let expectedSecondsTillStart;
    let injuryTimeClock;
    if (currentPeriod.status === 'live') {
        // if CLOCK RUNNING
        if (clockInfo.clockRunning) {
            ({ tillNextTick, clock, secondsSinceStart, injuryTimeClock } = getRunningClock_1.getRunningClock(sportName, clockInfo, periods, currentPeriodCode, config));
        } /* if CLOCK STOPPED */
        else {
            clock = formatClock_1.formatClock(Math.floor(clockInfo.clockInMs / 1000));
        }
    }
    else {
        const date = moment_1.default(matchDate);
        const utcNow = moment_1.default()
            .subtract(skewMsAdjustment, 'milliseconds')
            .toDate()
            .getTime();
        const startDate = getNextPeriodExpectedStartDate_1.getNextPeriodExpectedStartDate(date, sportName, periods, currentPeriodCode, config);
        secondsSinceStart = Math.floor((utcNow - startDate.getTime()) / 1000);
        expectedSecondsTillStart = startDate && Math.floor((startDate.getTime() - utcNow) / 1000);
        tillNextTick = startDate.getTime() - utcNow - expectedSecondsTillStart * 1000;
        countdownClock = formatClock_1.formatClock(expectedSecondsTillStart);
        countdown = secondsToDHMS(expectedSecondsTillStart);
    }
    return {
        clock,
        injuryTimeClock,
        countdownClock,
        countdown,
        tillNextTick,
        expectedSecondsTillStart,
        secondsSinceStart,
        running: clockInfo.clockRunning
    };
};
//# sourceMappingURL=calcClock.js.map